import AppComponent from '../../mixins/app-component'

import AppHomeSlideNbTitle from '../app-home-slide-nb-title'
import AppIcon from '../app-icon'

export default
{
    name: 'app-home-slide-3',

    mixins: [
        AppComponent
    ],

    components: {
        AppHomeSlideNbTitle,
        AppIcon
    },

    props: {
        activeIndex: { type: Number, default: 0 },
        activeLevel: { type: Number, default: 0 }
    },

    data() {
        return {
            currentLevel: 0,
            lastLevel: 0,
            comeFromPosition: 'right',

            // Slides
            slides: [{
                title: 'Map Location',
                content: [{
                    title: 'Type',
                    description: 'Public or Private'
                }, {
                    title: 'Traffic',
                    description: 'Low, Medium, High'
                }, {
                    title: 'Reachability',
                    description: 'Easy, Difficult'
                }]
            }, {
                title: 'Map Quality',
                content: [{
                    title: 'Distinct Surfaces',
                    description: 'Walls, Floor, Ceiling, Objects'
                }, {
                    title: 'Type of Surfaces',
                    description: 'Structural, Static, Moveable'
                }, {
                    title: 'Gaps in Mesh',
                    description: 'None, Few, Many'
                }]
            }, {
                title: 'Map Size',
                content: [{
                    title: 'Area Mapped',
                    description: 'Small, Large, Significant'
                }, {
                    title: 'Number of Areas',
                    description: 'Single, Multiple'
                }]
            }]
        }
    },

    watch: {
        activeIndex: 'onActiveLevelChange',
        activeLevel: 'onActiveLevelChange'
    },

    methods: {
        onActiveLevelChange() {
            if (this.activeIndex === 3) {
                this.lastLevel = this.currentLevel
                this.currentLevel = this.activeLevel

                if (this.currentLevel > this.lastLevel) {
                    this.comeFromPosition = 'right'
                } else if (this.currentLevel < this.lastLevel) {
                    this.comeFromPosition = 'left'
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-slide-3/script.js